export const Theme = {

  container: 'relative',
  wrapper: 'relative',

  input: [
    'bg-gray-50 border border-transparent border-solid text-gray-900 font-normal text-sm rounded-lg block w-full p-2.5 ring-transparent outline-none placeholder:text-neutral-400',
    'focus:border focus:border-primary-200 focus:ring focus:ring-primary-100',
    'disabled:bg-gray-200 disabled:text-neutral-400',
    'dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white',
    'dark:focus:ring-primary-700 dark:focus:border-primary-600'
  ],
  inputError: [
    'border border-danger',
    'focus:ring-danger-200 focus:border-danger',
    'dark:focus:ring-danger dark:focus:border-danger',
    'pr-8',
  ],

  startIconWrapper: [
    'absolute inset-y-0 left-0 flex items-center px-3.5 pointer-events-none space-x-4',
  ],
  endIconWrapper: [
    'absolute inset-y-0 right-0 flex items-center pl-3.5 pr-3.5 pointer-events-none space-x-4'
  ],
  endSuffixWrapper: [
    'absolute inset-y-0 right-0 flex items-center pl-3.5 pr-3.5 pointer-events-none space-x-4 bg-neutral-200 rounded-r-lg'
  ],
  endIconPasswordWrapper: [
    "absolute inset-y-0 right-2 flex items-center pl-3.5 cursor-pointer"
  ],
  svgIcon: [
    'w-4 h-4 text-gray-500 dark:text-gray-400'
  ]
};